// Source: https://github.com/maximakymenko/react-day-night-toggle-app/blob/master/src/global.js#L23-L41

import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: all 0.25s linear;
  }

.watermarked {
    position: relative;
    
    isolation: isolate; 
  }

  .watermarked::before {
    content: "PAGADO";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-30deg);
    font-size: 100px;
    font-weight: bold;
    pointer-events: none; 
    white-space: nowrap;
    letter-spacing: 8px;
    
    z-index: -1; 
    
    color: ${({ theme }) => theme.watermarkTextColor};
  }
  
  .watermarked::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    
    background-repeat: repeat;
    background-position: center;
    background-size: 100px 100px;
    pointer-events: none;
    z-index: 0;
    
  }
  
  @media print {
    .watermarked::before {
      color: ${({ theme }) => theme.watermarkTextColor} !important;
      font-size: 56px !important;
    }
  }
`;